import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from '../specialPromosBlocks/specialPromosBlocksSelector';

export const mortgageCalculatorSelector = createSelector(
  specialPromosBlocksSelector,
  state => state.mortgageCalculator,
);
